module.exports = __webpack_public_path__ + "img/2-1.21f2ce8a.png";